<template>
  <b-modal
    :active="isActive"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
    custom-class="modal-wrapper"
  >
    <div class="content">
      <h2>{{ $t('sign_off') }}</h2>
      <div v-if="currentTask.taskType === 'instruction'">
        {{
          $t('sign_off_questions_completed', {
            completed: questionsCompleteness,
            total: taskQuestions.length,
          })
        }}
      </div>

      <b-notification
        type="is-warning"
        :aria-close-label="$t('close_notification')"
        :closable="false"
        v-if="
          !checkQuestionCompletness && currentTask.taskType === 'instruction'
        "
        role="alert"
      >
        {{ $t('sign_off_instruction_not_completed') }}
      </b-notification>

      <b-notification
        type="is-warning"
        :aria-close-label="$t('close_notification')"
        :closable="false"
        v-if="
          currentTask.completenessPercentage !== 100 &&
          currentTask.taskType === 'diagram'
        "
        role="alert"
      >
        {{ $t('sign_off_diagram_not_completed') }}
      </b-notification>

      <div v-if="currentTask.taskType === 'diagram'">
        {{
          $t('sign_off_diagram_completed', {
            percent: parseFloat(currentTask.completenessPercentage).toFixed(2),
          })
        }}
      </div>
      <b-field :label="$t('sign_off_comments_label')">
        <b-input
          v-model="inspectorComments"
          maxlength="200"
          type="textarea"
        ></b-input>
      </b-field>
      <footer class="footer-buttons">
        <b-button :label="$t('close')" @click="onClose" />
        <b-button
          :label="$t('submit')"
          :disabled="submitInProgress"
          type="is-primary"
          @click="onSubmit"
        />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { GET_TASK_QUESTIONS } from '../../../store/questions/getters/getterTypes';
import { SAVE_TASK } from '../../../store/tasks/actions/actionTypes';
import { GET_CURRENT_TASK } from '../../../store/tasks/getters/getterTypes';

export default {
  name: 'SignOffDialog',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    async onSubmit() {
      this.submitInProgress = true;
      await this.$store.dispatch(SAVE_TASK, {
        ...this.currentTask,
        signedBy: this.currentUser.fullname,
        signedAt: new Date(),
        taskComment: this.inspectorComments,
        workStatusCode: '2',
      });
      this.submitInProgress = false;
      this.$emit('onSave');
    },
  },
  data() {
    return {
      inspectorComments: '',
      submitInProgress: false,
    };
  },
  computed: {
    currentTask() {
      return this.$store.getters[GET_CURRENT_TASK];
    },
    taskQuestions() {
      return this.$store.getters[GET_TASK_QUESTIONS];
    },
    questionsCompleteness() {
      let completedQuestions = 0;
      this.taskQuestions.forEach((instruction) => {
        if (
          instruction.inputValue ||
          instruction.checked ||
          instruction.yesOrNo
        ) {
          completedQuestions++;
        }

        if (instruction.type === 'multiplechoice') {
          if (
            instruction.multipleChoices.some(
              (choice) => choice.checked === true
            )
          ) {
            completedQuestions++;
          }
        }

        if (instruction.type === 'tablequestion') {
          let tableCompleted = true;
          for (let i = 1; i < instruction.tableData.length; i++) {
            for (let j = 1; j < instruction.tableData[i].length; j++) {
              if (
                instruction.tableData[i][j] === '' ||
                instruction.tableData[i][j] == null
              ) {
                tableCompleted = false;
                break;
              }
            }
          }

          if (tableCompleted) {
            completedQuestions++;
          }
        }
      });
      return completedQuestions;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    checkQuestionCompletness() {
      const mandatoryPicturesCompleted = !this.taskQuestions.some(
        (question) =>
          question.isPictureMandatory &&
          (!question.image || question.image.length === 0)
      );

      let allQuestionsCompleted = true;
      this.taskQuestions.forEach((question) => {
        switch (question.type) {
          case 'action':
            if (!question.checked) {
              allQuestionsCompleted = false;
            }
            break;

          case 'yesno':
            if (question.yesOrNo === '' || question.yesOrNo === null) {
              allQuestionsCompleted = false;
            }
            break;

          case 'multiplechoice':
            if (!question.multipleChoices.some((option) => option.checked)) {
              allQuestionsCompleted = false;
            }
            break;

          case 'textnumber':
            if (
              !question.inputValue ||
              question.inputValue === '' ||
              question.inputValue === null
            ) {
              allQuestionsCompleted = false;
            }
            break;

          default:
            break;
        }
      });

      return mandatoryPicturesCompleted && allQuestionsCompleted;
    },
  },
};
</script>

<style scoped>
.footer-buttons {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 20px;
}

.footer-buttons button {
  flex-grow: 1; /* Causes the buttons to grow and fill the container */
}

.modal-content {
  width: 100%;
  display: flex;
  justify-content: center;
}

.content {
  background: white;
  border-radius: 10px;
  padding: 38px;
  margin: 0 25%;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
</style>
